import React, { Dispatch, SetStateAction, useState } from 'react';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Box, Button, SxProps } from '@mui/material';
import { GridSelectionModel } from '@mui/x-data-grid-pro';

import { ConfirmModal } from 'components/modal';
import { ColunasDinamicasOpcoesFilter } from 'pages/cadastro/colunas-dinamicas/components/atoms/ColunasDinamicasOpcoesFilter';
import { ConfiguracaoPedidoCompraPesquisaField } from 'pages/compra/configuracao-pedido/components/atoms/ConfiguracaoPedidoCompraPesquisaField';

type ConfiguracaoPedidoHeaderActions = {
    searchPlaceholder?: string;
    setValueFilter?: Dispatch<SetStateAction<string>>;
    onClickAdd: () => void;
    sx?: SxProps;
    showSearchField?: boolean;
    addDisabled?: boolean;
};

export function HeaderColunasOpcoes({
    searchPlaceholder,
    setValueFilter = () => {},
    onClickAdd,
    sx,
    addDisabled,
}: ConfiguracaoPedidoHeaderActions): JSX.Element {
    return (
        <Box
            sx={{
                gap: 2,
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'normal',
                mb: 2,
                ...sx,
            }}
        >
            <ColunasDinamicasOpcoesFilter placeholder={searchPlaceholder} setValueFilter={setValueFilter} sx={{ mr: { xs: 'none', md: 'auto' } }} />

            <Button
                variant="contained"
                disabled={addDisabled}
                onClick={onClickAdd}
                sx={{
                    height: 33,
                    width: { xs: '100%', md: 'auto' },
                }}
            >
                Incluir
            </Button>
        </Box>
    );
}
